export const costumerServiceOyEmail = import.meta.env.VITE_CS_EMAIL_2;
export const onboardingOyEmail = import.meta.env.VITE_ONBOARDING_EMAIL;
